import { getLogger } from '@logtape/logtape'

const logger = getLogger(['capitalflow'])

const loggerFactory = (name) => {
  return getLogger(['capitalflow', name])
}

export { logger, loggerFactory }
